import React from "react"
import { createIcon } from "@chakra-ui/icons"
import { colours } from "@shared/ui.design-system"

export const Check = createIcon({
  displayName: "Check",
  viewBox: "0 0 24 24",
  defaultProps: {
    role: "img",
  },
  path: (
    <>
      <title> Check Icon </title>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect
          width="24"
          height="24"
          fill={colours.secondary.light}
          fillOpacity="0.01"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.2235 6.20679C20.4242 6.39652 20.433 6.71298 20.2433 6.91362L9.97328 17.7736C9.8805 17.8717 9.75199 17.9281 9.61697 17.93C9.48196 17.9319 9.35192 17.8791 9.25644 17.7836L3.76644 12.2936C3.57118 12.0984 3.57118 11.7818 3.76644 11.5865C3.9617 11.3913 4.27829 11.3913 4.47355 11.5865L9.59999 16.713L19.5167 6.22652C19.7064 6.02589 20.0229 6.01705 20.2235 6.20679Z"
          fill="currentColor"
        />
      </svg>
    </>
  ),
})
